import React from 'react';
import { FaCalendarAlt, FaClipboardList, FaTasks } from 'react-icons/fa';
import './StaffDashboard.css';

const mockSchedule = [
  { id: 1, type: 'Task', title: 'Inspect Fire Doors', date: '2024-06-20', property: 'ABC Tower' },
  { id: 2, type: 'Inspection', title: 'Monthly Fire Alarm Test', date: '2024-06-21', property: 'ABC Tower' },
  { id: 3, type: 'Task', title: 'Replace PPE', date: '2024-06-22', property: 'Main Office' },
];

export default function MySchedule() {
  return (
    <div className="calendar-grid">
      {mockSchedule.map(item => (
        <div className="calendar-item" key={item.id}>
          <div className="calendar-date">
            <span className="month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</span>
            <span className="day">{new Date(item.date).getDate()}</span>
          </div>
          <div className="calendar-info">
            <h4>{item.title}</h4>
            <p>Type: {item.type}</p>
            <p>Property: {item.property}</p>
            <p className="time"><FaCalendarAlt /> {item.date}</p>
          </div>
        </div>
      ))}
    </div>
  );
} 